import { useGroupeForm } from "../hooks/use-groupe-form";
import { CreateGroupeFormFields } from "./create-groupe-form-fields";

interface CreateGroupeFormProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export function CreateGroupeForm({ onCancel, onSuccess }: CreateGroupeFormProps) {
  const {
    formData,
    error,
    isLoading,
    isPending,
    subscriptionConfig,
    selectedPlanType,
    selectedTierId,
    handleInputChange,
    handleSelectChange,
    handleSubmit,
    handlePlanSelect,
  } = useGroupeForm({ onSuccess });

  if (isLoading) {
    return <div className="flex justify-center p-4">Chargement des données...</div>;
  }

  return (
    <CreateGroupeFormFields
      formData={formData}
      error={error}
      isPending={isPending}
      subscriptionConfig={subscriptionConfig}
      selectedPlanType={selectedPlanType}
      selectedTierId={selectedTierId}
      onCancel={onCancel}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      handleSubmit={handleSubmit}
      handlePlanSelect={handlePlanSelect}
    />
  );
}
